require('../../../modules/es.array.every');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').every;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/array/virtual/every.js
// module id = 972
// module chunks = 0